import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const eventAvailability = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    hasMedicalConditions: z
      .enum(['Yes', 'No'])
      .nullable()
      .optional()
      .describe('Whether the candidate has specific medical conditions.'),

    medicalConditionDetails: z
      .string()
      .nullable()
      .optional()
      .describe('Description of medical conditions if any.'),

    disability: z
      .string()
      .nullable()
      .optional()
      .describe('Description of disability if any.'),

    dataConsentToThirdParty: z
      .enum(['Yes', 'No'])
      .nullable()
      .optional()
      .describe('Consent for personal data availability to third party.'),

    uniformSize: z
      .enum(['2XS', 'XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'])
      .nullable()
      .optional()
      .describe('Uniform shirt size.'),

    hasCriminalConvictions: z
      .enum(['Yes', 'No'])
      .nullable()
      .optional()
      .describe('Whether the candidate has any criminal convictions.'),

    candidateId: z.number().hidden().describe('Foreign key to Candidate'),

    candidate: belongsTo('Candidate'),
  })
  .describe(
    'Medical, legal, and logistical availability details for event participation.',
  )
  .as('EventAvailability');

export { eventAvailability as eventAvailabilitySchema };
